module.exports = SharedDependencies.ReactDOM['application'];